document.querySelectorAll('.search-page__tab').forEach((searchTabNode) => {
    searchTabNode.addEventListener('click', () => {
        const key = searchTabNode.getAttribute('data-key')

        if (!searchTabNode.classList.contains('search-page__tab_empty')) {
            const dataNode = document.querySelector(`.search-page__data[data-key=${ key }`)


            document.querySelectorAll('.search-page__data_show').forEach((dataShowNode) => {
                dataShowNode.classList.remove('search-page__data_show')
            })

            document.querySelectorAll('.search-page__tab_selected').forEach((searchTabSelectedNode) => {
                searchTabSelectedNode.classList.remove('search-page__tab_selected')
            })


            searchTabNode.classList.add('search-page__tab_selected')

            if (dataNode) {
                dataNode.classList.add('search-page__data_show')
            }
        }
    })
})